import PusherJS from "pusher-js";
import store from "../store";
import tenant from "./tenant";

const waitForTenantConfig = async ({
  interval = 200,
  timeout = 10000,
} = {}) => {
  const start = Date.now();

  return new Promise((resolve, reject) => {
    const check = () => {
      if (tenant.getPusherKey()) {
        resolve();
        return;
      }

      if (Date.now() - start >= timeout) {
        reject(new Error("Pusher tenant config not available"));
        return;
      }

      setTimeout(check, interval);
    };

    check();
  });
};

const ws = {
  wsClient: null,
  initPromise: null,

  async init(token = null) {
    if (token === null) {
      token = store.state.token;
    }

    // Prevent multiple parallel inits
    if (!this.initPromise) {
      this.initPromise = (async () => {
        await waitForTenantConfig();

        if (this.wsClient === null) {
          this.wsClient = new PusherJS(tenant.getPusherKey(), {
            wsHost: tenant.getPusherDomain(),
            wsPort: process.env.VUE_APP_PUSHER_PORT,
            httpHost: tenant.getPusherHttpHost(),
            authEndpoint: tenant.getPusherAuthEndpoint(),
            forceTLS: process.env.VUE_APP_PUSHER_FORCETLS === "true",
            auth: {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
            encrypted: true,
            disableStats: true,
            enabledTransports: ["ws", "wss"],
          });
        } else {
          this.wsClient.config.auth.headers.Authorization = `Bearer ${token}`;
        }
      })();
    }

    return this.initPromise;
  },

  async subscribe(channel, event, resolve) {
    await this.init();

    this.wsClient.subscribe(`private-${channel}`).bind(event, (e) => {
      resolve(e);
    });
  },
};

export default ws;
